import React, { useEffect, useState, useMemo } from "react";
import { useLoader } from '../../../../context/LoaderProvider.jsx';

const Eventenquery = () => {
    const [data, setData] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
    const { showLoader, hideLoader } = useLoader();
    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        const token = localStorage.getItem("authToken"); // get token from localStorage

        const fetchUsers = async () => {
            try {
                showLoader();
                const res = await fetch(
                    "https://backend.maamaas.com/subscription/api/admin/enquiries/getall",
                    {
                        signal: controller.signal,
                        headers: {
                            "Authorization": `Bearer ${token}`, // ✅ attach token here
                            "Content-Type": "application/json"
                        }
                    }
                );

                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

                const fetchedData = await res.json();

                // Optional: store auth token from response if returned
                if (fetchedData.authToken) {
                    localStorage.setItem("authToken", fetchedData.authToken);
                }

                // Filter data based on businessVerticals
                const filteredData = fetchedData.filter(item =>
                    item.businessVerticals?.includes("FOOD_AND_BEVERAGES")
                );

                // Add extra fields
                const dataWithExtras = filteredData.map((item, index) => ({
                    ...item,
                    sno: index + 1,
                    category: item.category || "N/A",
                    subscription: item.subscription || "N/A",
                    isInterestedInSales: null, // can be 'yes' or 'no'
                }));

                setData(dataWithExtras);

            } catch (err) {
                if (err.name !== "AbortError") console.error("Error fetching users:", err);
            } finally {
                hideLoader();
            }
        };

        fetchUsers();
        return () => controller.abort();
    }, []);



    const filteredData = useMemo(() => {
        return data.filter(user => {
            const statusMatch =
                !selectedStatusFilter ||
                (user.statusAsDeliveryAgent &&
                    user.statusAsDeliveryAgent.toLowerCase() === selectedStatusFilter.toLowerCase());
            return statusMatch;
        });
    }, [data, selectedStatusFilter]);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12" style={{ marginTop: "0px" }}>
                    <div
                        className="user-management-page"
                        style={{
                            overflowY: "auto",
                            height: "70vh",
                            scrollbarWidth: "thin",
                            marginTop: "15px",
                        }}
                    >
                        <div className="user-management-container" style={{ marginLeft: "0px" }}>



                            <div className="user-table-wrapper">
                                <table style={{ width: "100%", fontSize: "0.95rem", borderCollapse: "collapse" }}>
                                    <thead>
                                        <tr>
                                            <th style={tableHeaderStyle}>S.NO</th>
                                            <th style={tableHeaderStyle}>Name</th>
                                            <th style={tableHeaderStyle}>Email</th>
                                            <th style={tableHeaderStyle}>Phone</th>
                                            <th style={tableHeaderStyle}>City</th>
                                            {/* <th style={tableHeaderStyle}>Vertical</th>
                                            <th style={tableHeaderStyle}>Company</th> */}
                                            <th style={tableHeaderStyle}>Vendor ID</th>
                                            {/* <th style={tableHeaderStyle}>Interested</th> */}
                                            {/* <th style={tableHeaderStyle}>Reminder</th> */}
                                            {/* <th style={tableHeaderStyle}>Remarks</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.length > 0 ? (
                                            filteredData.map((user, index) => (
                                                <tr key={user.vendorId || index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff" }}>
                                                    <td style={tableCellStyle}>{user.sno}</td>
                                                    <td style={tableCellStyle}>{user.name}</td>
                                                    <td style={tableCellStyle}>{user.email}</td>
                                                    <td style={tableCellStyle}>{user.mobileNumber}</td>
                                                    <td style={tableCellStyle}>{user.city}</td>
                                                    {/* <td style={tableCellStyle}>{user.businessVertical}</td>
                                                    <td style={tableCellStyle}>{user.companyName}</td> */}
                                                    <td style={tableCellStyle}>{user.vendorId}</td>
                                                    {/* <td style={tableCellStyle}>
                                                        <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                                                            <button
                                                                onClick={() => handleInterestClick(index, "yes")}
                                                                style={{
                                                                    padding: "5px 10px",
                                                                    backgroundColor: user.isInterestedInSales === "yes" ? "#28a745" : "#ccc",
                                                                    color: "#fff",
                                                                    border: "none",
                                                                    borderRadius: "4px",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                Yes
                                                            </button>
                                                            <button
                                                                onClick={() => handleInterestClick(index, "no")}
                                                                style={{
                                                                    padding: "5px 10px",
                                                                    backgroundColor: user.isInterestedInSales === "no" ? "#dc3545" : "#ccc",
                                                                    color: "#fff",
                                                                    border: "none",
                                                                    borderRadius: "4px",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                No
                                                            </button>
                                                        </div>
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        <button
                                                            onClick={() => handleSendReminder(user.email)}
                                                            style={{
                                                                padding: "4px 8px",
                                                                fontSize: "0.85rem",
                                                                backgroundColor: "#007bff",
                                                                color: "white",
                                                                border: "none",
                                                                borderRadius: "4px",
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            Send
                                                        </button>
                                                    </td> */}
                                                    {/* <td style={tableCellStyle}>{user.remarks}</td> */}
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="10" style={noDataStyle}>
                                                    Loading data or no customers found.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Styles
const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
    padding: "6px",
};

const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    padding: "6px",
};

const noDataStyle = {
    fontStyle: "italic",
    textAlign: "center",
    padding: "10px",
    color: "#888",
};

export default Eventenquery;